

export const section = {
    iphone13Pro: {
        heading: 'iPhone 13 Pro',
        headColor: '#1d1d1f',
        subHeading: 'Oh. So. Pro.',
        subHeadColor: '#1d1d1f',
        imageURL: 'https://www.apple.com/v/home/ag/images/heroes/iphone-13-pro/hero_iphone_13pro__dhnsegysa42u_large.jpg',
        learn: 'https://www.apple.com/ge/iphone-13-pro/',
        buy: 'https://www.apple.com/ge/iphone-13-pro/',
    },
    iphone13: {
        heading: 'iPhone 13',
        headColor: '#f5f5f7',
        subHeading: 'Your new superpower',
        subHeadColor: '#fec2eb',
        imageURL: 'https://www.apple.com/v/home/ag/images/heroes/iphone-13/hero_iphone_13__f194u1rdooeq_large.jpg',
        learn: 'https://www.apple.com/ge/iphone-13/',
        buy: 'https://www.apple.com/ge/iphone-13/',
    },
    macbookpro: {
        heading: 'MacBook Pro',
        headColor: '#1d1d1f',
        subHeading: 'Supercharged for pros',
        subHeadColor: '#1d1d1f',
        imageURL: 'https://www.apple.com/v/home/ag/images/heroes/macbook-pro/hero_macbookpro__eatonjfwvuc2_large.jpg',
        learn: 'https://www.apple.com/in/macbook-pro/',
        buy: 'https://www.apple.com/in/macbook-pro/',
    }
}